import React, { useEffect } from "react";
import Highcharts from "highcharts";
import "highcharts/modules/heatmap";

const SectorHeatmap = ({ data, title = "Sector Rotation Heatmap" }) => {
  useEffect(() => {
    if (!data || data.length === 0) return;

    // Data is already filtered by parent component
    if (data.length === 0) return;

    const chart = Highcharts.chart("sector-heatmap-container", {
      chart: {
        type: "treemap",
        height: "500px",
      },
      title: {
        text: title,
      },
      series: [
        {
          type: "treemap",
          layoutAlgorithm: "squarified",
          data: data.map((item) => ({
            name: item.sectorName,
            value: Math.abs(item.flowScore), // Size based on absolute value
            flowScore: item.flowScore, // Store actual flow score (percentage)
            flowDirection: item.flowDirection,
            // Simple light red and green colors
            color: item.flowScore > 0 
              ? "rgba(0, 200, 0, 0.5)"  // Light green for inflow
              : "rgba(200, 0, 0, 0.5)", // Light red for outflow
          })),
          dataLabels: {
            enabled: true,
            format: "{point.name}<br/>{point.flowScore:+.1f}%", // Show as percentage
            style: {
              fontSize: "12px",
              fontWeight: "bold",
              textOutline: "1px contrast",
            },
          },
        },
      ],
      tooltip: {
        formatter: function() {
          const direction = this.point.flowScore > 0 ? 'INFLOW ↗' : 'OUTFLOW ↘';
          const color = this.point.flowScore > 0 ? '#52c41a' : '#f5222d';
          return `<b>${this.point.name}</b><br/>` +
                 `Net Flow: <b style="color: ${color}">${this.point.flowScore > 0 ? '+' : ''}${this.point.flowScore.toFixed(2)}%</b><br/>` +
                 `Direction: <b style="color: ${color}">${direction}</b>`;
        },
      },
    });

    return () => {
      if (chart) {
        chart.destroy();
      }
    };
  }, [data, title]);

  return (
    <div
      id="sector-heatmap-container"
      style={{ width: "100%", minHeight: "500px" }}
    />
  );
};

export default SectorHeatmap;


